import React, { useState } from 'react';
import { Sparkles, ExternalLink, Search } from 'lucide-react';

const CLEANING_SITES = [
    { name: '세스코', url: 'https://www.cesco.co.kr/', desc: '종합 위생 관리 서비스, 병원 방역 전문' },
    { name: '클린마스터', url: 'https://www.clean-master.co.kr/', desc: '종합청소대행 전문, 병원 청소 서비스' },
    { name: '팀에스클린', url: 'https://team-sclean.com/', desc: '병원 전문 청소 서비스' },
    { name: '클린다오', url: 'https://cleandao.kr/', desc: '최신 기술 병원 환경 청소 전문' },
    { name: '크린몬', url: 'https://www.cleanmon.co.kr/', desc: '청소대행 전문업체, 병원 청소' },
    { name: '3C청소종합회사', url: 'https://3c-clean.com/', desc: '서울·경기 병원 청소 전문' },
    { name: '크린앤서비스', url: 'https://www.cleannservice.com/', desc: '종합 청소 전문 기업' },
    { name: '한국방역협회', url: 'https://ikpca.co.kr/', desc: '사단법인 방역 협회, 소독·방역 정보' },
];

const WASTE_SITES = [
    { name: '메디고고', url: 'https://medigogo.co.kr/', desc: '의료폐기물 전용용기 제공·수거 서비스' },
    { name: '스테리싸이클 코리아', url: 'https://www.stericycle.co.kr/', desc: '글로벌 의료폐기물 수거·처리 전문' },
    { name: '올바로 시스템', url: 'https://www.allbaro.or.kr/', desc: '환경부 폐기물 종합관리 시스템' },
    { name: '한국환경공단', url: 'https://www.keco.or.kr/', desc: '환경부 산하 폐기물 관리 공단' },
    { name: '나비엠알오', url: 'https://www.navimro.com/', desc: '의료폐기물 전용용기 구매 쇼핑몰' },
    { name: '오픈메디칼', url: 'https://openmedical.co.kr/', desc: '의료기기 종합쇼핑몰, 폐기물용기 판매' },
    { name: '메디세일', url: 'https://medisale.co.kr/', desc: '병원 의료소모품 도매, 폐기물용기' },
    { name: '자바드림', url: 'https://javadrim.com/', desc: '해충방역 전문, 의료시설 소독 서비스' },
];

function Cleaning() {
    const [tab, setTab] = useState('cleaning');
    const [searchTerm, setSearchTerm] = useState('');

    const sites = tab === 'cleaning' ? CLEANING_SITES : WASTE_SITES;
    const filtered = sites.filter(s => {
        if (!searchTerm) return true;
        const q = searchTerm.toLowerCase();
        return s.name.toLowerCase().includes(q) || s.desc.toLowerCase().includes(q);
    });

    return (
        <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
            <h1 style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 24, fontWeight: 700, margin: '0 0 20px' }}>
                <Sparkles size={28} color="#059669" /> 청소·폐기물
            </h1>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {[['cleaning', '청소·소독'], ['waste', '의료폐기물']].map(([k, v]) => (
                    <button key={k} onClick={() => { setTab(k); setSearchTerm(''); }}
                        style={{ padding: '10px 20px', border: '1px solid #e5e7eb', borderRadius: 10, background: tab === k ? '#d1fae5' : '#fff', color: tab === k ? '#065f46' : '#374151', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                        {v}
                    </button>
                ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: 10, marginBottom: 20 }}>
                <Search size={16} color="#9ca3af" />
                <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="업체 검색" style={{ border: 'none', outline: 'none', flex: 1, fontSize: 14 }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {filtered.map(s => (
                    <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, textDecoration: 'none', color: '#1f2937' }}>
                        <div>
                            <h3 style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 600 }}>{s.name}</h3>
                            <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>{s.desc}</p>
                        </div>
                        <ExternalLink size={18} color="#059669" style={{ flexShrink: 0 }} />
                    </a>
                ))}
            </div>
        </div>
    );
}

export default Cleaning;
